import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Layout, Row, Col, Modal, Tabs, Spin, Input } from 'antd';
import { Icon, Toast, Picker, List, Modal as ModalMobile } from 'antd-mobile'
import { withTranslation } from 'react-i18next';
import * as SignalR from '@aspnet/signalr';
import basketImage from '../../assets/image/Icon/BasketCart.svg';
import LaundryDetailModal from './laundryDetailModal';
import LaundryTabPage from './laundryTab';
import { Markup } from 'interweave';
import IdleTimer from 'react-idle-timer';

const { Content } = Layout;
const { Search } = Input;
const { TabPane } = Tabs;
const REACT_APP_SIGNALR_URL = `${process.env.REACT_APP_STAYMENU_API_URL}/stayMenuHub`;
const confirmAlert = ModalMobile.alert;

@inject(
    'VersionStore',
    'templateStore',
    'CmsLanguageStore',
    'popupStore',
    'laundryStore',
    'loginStore',
    'webSettingStore'
)
@observer
class LaundryMainPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            popupContent: null,
        }
    }

    componentDidMount() {
        const roomNo = this.props.loginStore.getRoomNo();
        if (!roomNo) {
            this.props.history.push('/login');
        }

        this.props.loginStore.authenticateGuest().then(response => {
            if (!response) {
                this.props.history.push('/login');
            }
        });

        this.props.CmsLanguageStore.getActives().then(() => {
            this.props.webSettingStore.getData().then(() => {
                this.props.templateStore.getActive().then(() => {
                    const { activeTemplate } = this.props.templateStore;
                    const { data: webSettting } = this.props.webSettingStore;

                    if (webSettting) {
                        this.props.popupStore.getByModuleName('LAUNDRY').then(resp => {
                            if (resp && resp.title) {
                                this.setState({ popupContent: resp });
                            }
                        });

                    }
                });
            });
        });

        this.props.laundryStore.initTotalLaundryOrder(roomNo);
        this.props.laundryStore.setShowLaundryDetailModal(false);
        this.props.laundryStore.initGetLaundries(roomNo);

        let connection = new SignalR.HubConnectionBuilder().withUrl(REACT_APP_SIGNALR_URL).build();
        connection.start().catch(function (err) { return console.error(err.toString()); });
        connection.on(`SignalR_SyncData`, () => { window.location.reload(true); });
    }

    componentDidUpdate() {
        this.tabStyle();
        this.stepperStyle();
    }

    componentWillUnmount() {
        this.props.laundryStore.resetData();
    }

    tabStyle = () => {
        const { activeTemplate } = this.props.templateStore;

        const { data: webSettting } = this.props.webSettingStore;

        if (webSettting) {
            const tabs = document.getElementsByClassName('ant-tabs-tab');

            for (let i = 0; i < tabs.length; i++) {
                tabs[i].style.fontFamily = `${activeTemplate.templateSetting.tab.fontFamily}`;
                tabs[i].style.fontSize = `${activeTemplate.templateSetting.tab.fontSize}px`;
                tabs[i].style.lineHeight = `${activeTemplate.templateSetting.tab.fontSize + 2}px`;
                tabs[i].style.color = activeTemplate.templateSetting.tab.color;
            }

            const tabActives = document.getElementsByClassName('ant-tabs-tab-active');

            for (let i = 0; i < tabActives.length; i++) {
                tabActives[i].style.fontFamily = `${activeTemplate.templateSetting.tabSelected.fontFamily}`;
                tabActives[i].style.fontSize = `${activeTemplate.templateSetting.tabSelected.fontSize}px`;
                tabActives[i].style.lineHeight = `${activeTemplate.templateSetting.tabSelected.fontSize + 2}px`;
                tabActives[i].style.color = activeTemplate.templateSetting.tabSelected.color;
            }

            const tabInk = document.getElementsByClassName('ant-tabs-ink-bar');

            for (let i = 0; i < tabInk.length; i++) {
                tabInk[i].style.background = `${activeTemplate.templateSetting.tabSelected.color}`;
            }
        }
    }

    stepperStyle = () => {
        const { activeTemplate } = this.props.templateStore;

        const { data: webSettting } = this.props.webSettingStore;

        if (webSettting) {
            const steppers = document.getElementsByClassName('am-stepper-handler');

            for (let i = 0; i < steppers.length; i++) {
                steppers[i].style.fontFamily = `${activeTemplate.templateSetting.text.fontFamily}`;
                steppers[i].style.background = activeTemplate.templateSetting.header.backgroundColor;
                steppers[i].style.borderColor = activeTemplate.templateSetting.header.backgroundColor;
            }
        }
    }

    // ON CHANGE

    searchText = (e) => {
        this.props.laundryStore.setLaundrySearchText(e.target.value);
        this.props.laundryStore.searchLaundryByNameAndSubCategory();
    }

    selectBySubCategory = (subCategories) => {
        const subCategory = subCategories[0];
        this.props.laundryStore.setLaundrySearchSubCategory(subCategory);
        this.props.laundryStore.searchLaundryByNameAndSubCategory();
    }

    // ON CLICK

    goToConfirmPage = () => {
        const { data: webSettting } = this.props.webSettingStore;

        const {
            laundryItems
        } = this.props.laundryStore;

        let orderLaundryItems = [];

        if (laundryItems) {
            if (laundryItems.length > 0) {
                orderLaundryItems = laundryItems.filter(fi => fi.orderQuantity > 0);

                if (orderLaundryItems.length === 0) {
                    Toast.fail(webSettting.pleaseSelectYourOrderText, 1);
                    return;
                }
            }
        }

        const roomNo = this.props.loginStore.getRoomNo();
        const laundryPendingOrders = this.props.laundryStore.goToLaundryConfirmPage(roomNo);

        if (laundryPendingOrders.length !== 0) {
            this.props.history.push('/laundry-confirm');
        }
    }

    back = () => {
        this.props.history.goBack();
    }

    // ON TAB CLICK

    tabClick = (key) => {
        const categoryTaskId = key.toString();
        this.props.laundryStore.setLaundryTabSubCategoriesByTabCategoryTaskId(categoryTaskId);
        this.props.laundryStore.setShowLaundryDetailModal(false);
        this.props.laundryStore.setLaundrySearchText('');
        this.props.laundryStore.setLaundrySearchSubCategory('All');
        this.props.laundryStore.searchLaundryByNameAndSubCategory();
    }

    // ON TOUCH

    _onTouchStart(e, that) {
        const touch = e.touches[0];
        that.props.laundryStore.setSwipeX(touch.clientX);
        that.props.laundryStore.setIsSwipe(false);
    }

    _onTouchMove(e, that) {
        if (e.changedTouches && e.changedTouches.length) {
            that.props.laundryStore.setIsSwipe(true);
        }
    }

    _onTouchEnd(e, that, categoryTaskId) {
        const { swipeX, isSwipe, laundryTabCategories } = that.props.laundryStore;
        const touch = e.changedTouches[0];
        const absX = Math.abs(touch.clientX - swipeX);
        if (isSwipe && absX > 50) {
            if (touch.clientX - swipeX < 0) {
                let nextCategoryTaskId = 0;
                for (let i = 0; i < laundryTabCategories.length; i += 1) {
                    if (laundryTabCategories[i].taskId === categoryTaskId) {
                        if (laundryTabCategories[i + 1]) {
                            nextCategoryTaskId = laundryTabCategories[i + 1].taskId;
                            that.tabClick(nextCategoryTaskId);
                        }
                        return;
                    }
                }
            } else {
                let prevCategoryTaskId = 0;
                for (let i = 0; i < laundryTabCategories.length; i += 1) {
                    if (laundryTabCategories[i].taskId === categoryTaskId) {
                        if (laundryTabCategories[i - 1]) {
                            prevCategoryTaskId = laundryTabCategories[i - 1].taskId;
                            that.tabClick(prevCategoryTaskId);
                        }
                        return;
                    }
                }
            }
        }

        that.props.laundryStore.setSwipeX(0);
        that.props.laundryStore.setIsSwipe(false);
    }

    checkSmVersion = () => {
        this.props.VersionStore.check().then(resp => {
            if (!resp) {
                const { activeTemplate } = this.props.templateStore;
                const { data: webSettting } = this.props.webSettingStore;

                confirmAlert(
                    <div
                        style={{
                            fontFamily: activeTemplate.templateSetting.label.fontFamily,
                            color: activeTemplate.templateSetting.label.color,
                            fontSize: activeTemplate.templateSetting.label.fontSize,
                            lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                        }}>
                        <span>Info</span>
                    </div>,
                    <div
                        style={{
                            fontFamily: activeTemplate.templateSetting.text.fontFamily,
                            color: activeTemplate.templateSetting.text.color, fontSize: activeTemplate.templateSetting.text.fontSize,
                            lineHeight: `${activeTemplate.templateSetting.text.fontSize + 6}px`, textAlign: 'center'
                        }}>
                        <span>New version has been released. Please refresh the page.</span>
                    </div>, [
                    {
                        text:
                            <span
                                style={{
                                    fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                    color: activeTemplate.templateSetting.label.color,
                                    fontSize: activeTemplate.templateSetting.label.fontSize,
                                    lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                                }}
                            >
                                {webSettting.okText}
                            </span>,
                        onPress: () => {
                            window.location.reload(true);
                        }
                    }
                ]);
            }
        });
    }

    render() {
        const { activeTemplate } = this.props.templateStore;

        const {
            menu,
            showLaundryDetailModal,
            laundryTabCategories,
            laundryItems,
            laundryFilterItems,
            laundrySearchText,
            laundrySearchSubCategory,
            laundryTabSubCategories,
            laundryTabCategoryIdActive,
            laundryTotalOrder
        } = this.props.laundryStore;

        const { data: webSettting } = this.props.webSettingStore;

        return (
            <>
                {
                    activeTemplate
                        ?
                        <>
                            <Layout className='stm-layout'>
                                <IdleTimer ref={ref => { this.idleTimer = ref }} timeout={1000 * 5} onIdle={this.checkSmVersion} debounce={250} />
                                <>
                                    {
                                        webSettting
                                            ?
                                            <>
                                                <Modal
                                                    className='stm-modal'
                                                    title='Laundry Detail'
                                                    onCancel={() => { this.props.laundryStore.setShowLaundryDetailModal(false) }}
                                                    visible={showLaundryDetailModal}
                                                >
                                                    <LaundryDetailModal />
                                                </Modal>

                                                <Content>
                                                    {/* Header */}
                                                    <Row>
                                                        <Col
                                                            span={24}
                                                            className='stm-position-fixed stm-top-0 stm-z-index-100000 stm-max-width-500'
                                                            style={{
                                                                fontFamily: activeTemplate.templateSetting.header.fontFamily,
                                                                background: activeTemplate.templateSetting.header.backgroundColor,
                                                                color: activeTemplate.templateSetting.header.color,
                                                                fontSize: activeTemplate.templateSetting.header.fontSize,
                                                                lineHeight: `${activeTemplate.templateSetting.header.fontSize + 2}px`
                                                            }}
                                                        >
                                                            <Row>
                                                                <Col span={4} className='stm-display-flex stm-align-items-center stm-justify-content-center stm-height-50' onClick={this.back}>
                                                                    <Icon type='left' size='lg' color={activeTemplate.templateSetting.header.color} />
                                                                </Col>
                                                                <Col span={16} className='stm-display-flex stm-align-items-center stm-justify-content-center stm-height-50'>
                                                                    {menu ? menu.taskName : ''}
                                                                </Col>
                                                                <Col span={4} />
                                                            </Row>
                                                        </Col>
                                                    </Row>

                                                    {/* Body */}
                                                    {menu != null && String(menu.isShown) === 'false' ? (
                                                      <Row style={{ marginTop: 50 }}>
                                                        <Col span={24} style={{
                                                          display: 'flex',
                                                          flexDirection: 'column',
                                                          alignItems: 'center',
                                                          Height: '25vh',
                                                        }}>
                                                          {menu.bannerUrl && (
                                                            <img
                                                              src={menu.bannerUrl}
                                                              alt={menu.taskName || 'unavailable'}
                                                              style={{
                                                                width: '100%',
                                                                height: '25vh',
                                                                objectFit: 'cover',
                                                              }}
                                                            />
                                                          )}
                                                          {this.state.popupContent && (
                                                            <>
                                                              {this.state.popupContent.description && (
                                                                <div style={{
                                                                  marginTop: 12,
                                                                  fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                                  color: activeTemplate.templateSetting.text.color,
                                                                  fontSize: activeTemplate.templateSetting.text.fontSize,
                                                                  textAlign: 'center',
                                                                  padding: '0 20px',
                                                                }}>
                                                                  <Markup content={this.state.popupContent.description} />
                                                                </div>
                                                              )}
                                                            </>
                                                          )}
                                                        </Col>
                                                      </Row>
                                                    ) : (
                                                      <>
                                                        {
                                                            laundryTabCategories.length === 0 && laundryItems.length === 0
                                                                ?
                                                                <>
                                                                    <Row>
                                                                        <Col span={24} className='stm-margin-top-150 stm-text-align-center'>
                                                                            <Spin
                                                                                spinning={true}
                                                                                tip={webSettting.loadingDataText}
                                                                                style={{
                                                                                    fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                                                    color: activeTemplate.templateSetting.text.color,
                                                                                    fontSize: activeTemplate.templateSetting.text.fontSize
                                                                                }}>
                                                                            </Spin>
                                                                        </Col>
                                                                    </Row>
                                                                </>
                                                                :
                                                                <Row>
                                                                    <Col span={24} className='stm-margin-top-50'>
                                                                        <Tabs
                                                                            activeKey={laundryTabCategoryIdActive}
                                                                            className='stm-tab'
                                                                            type='line'
                                                                            onTabClick={this.tabClick}
                                                                            style={{
                                                                                fontFamily: activeTemplate.templateSetting.tab.fontFamily,
                                                                                color: activeTemplate.templateSetting.tab.color,
                                                                                fontSize: activeTemplate.templateSetting.tab.fontSize,
                                                                                lineHeight: `${activeTemplate.templateSetting.tab.fontSize + 2}px`
                                                                            }}
                                                                        >
                                                                            {
                                                                                laundryTabCategories.map((tab) => {
                                                                                    let itemFilters = laundryFilterItems.filter(fi => fi.categoryId === tab.taskId);

                                                                                    return (
                                                                                        <TabPane tab={tab.taskName} key={tab.taskId} className='stm-tabpane'>
                                                                                            <div className='stm-tab-filter-wrapper'>
                                                                                                <Row className='stm-tab-filter-container'>
                                                                                                    <Col span={24} className='stm-tab-filter'>
                                                                                                        <Search
                                                                                                            placeholder={webSettting.searchText}
                                                                                                            value={laundrySearchText}
                                                                                                            onChange={this.searchText} />
                                                                                                    </Col>
                                                                                                    <>
                                                                                                        {
                                                                                                            laundryTabSubCategories.length > 0
                                                                                                                ?
                                                                                                                <Col span={24} className='stm-tab-filter'>
                                                                                                                    <Picker
                                                                                                                        data={[laundryTabSubCategories]}
                                                                                                                        title='Select Sub Category'
                                                                                                                        cascade={false}
                                                                                                                        value={[laundrySearchSubCategory]}
                                                                                                                        okText={webSettting.okText}
                                                                                                                        dismissText={webSettting.cancelText}
                                                                                                                        onOk={this.selectBySubCategory}
                                                                                                                    >
                                                                                                                        <List.Item>
                                                                                                                            <Row className='stm-margin-bottom-2'>
                                                                                                                                <Col span={24} className='stm-list-category'>
                                                                                                                                    <Row
                                                                                                                                        className='stm-width-100-percent'
                                                                                                                                        style={{
                                                                                                                                            fontFamily: activeTemplate.templateSetting.buttonItem.fontFamily,
                                                                                                                                            fontSize: activeTemplate.templateSetting.buttonItem.fontSize,
                                                                                                                                            lineHeight: `${activeTemplate.templateSetting.buttonItem.fontSize + 2}px`,
                                                                                                                                            color: activeTemplate.templateSetting.buttonItem.color,
                                                                                                                                            backgroundColor: activeTemplate.templateSetting.buttonItem.backgroundColor
                                                                                                                                        }}
                                                                                                                                    >
                                                                                                                                        <Col span={20}>
                                                                                                                                            {laundrySearchSubCategory}
                                                                                                                                        </Col>
                                                                                                                                        <Col span={4} className='stm-text-align-right stm-padding-right-10'>
                                                                                                                                            <img src={require('../../assets/image/Icon/Arrow-Down.svg')} alt='Arrow-Down' className='stm-width-16 stm-height-16' />
                                                                                                                                        </Col>
                                                                                                                                    </Row>
                                                                                                                                </Col>
                                                                                                                            </Row>
                                                                                                                        </List.Item>
                                                                                                                    </Picker>
                                                                                                                </Col>
                                                                                                                :
                                                                                                                null
                                                                                                        }
                                                                                                    </>
                                                                                                </Row>
                                                                                            </div>

                                                                                            {/* Category Description */}
                                                                                            <>
                                                                                                {
                                                                                                    tab.taskDesc === null || tab.taskDesc === ''
                                                                                                        ?
                                                                                                        <div style={{
                                                                                                            marginTop: laundryTabSubCategories.length > 0 ? 122 : 72,
                                                                                                        }}></div>
                                                                                                        :
                                                                                                        <Row className='stm-tab-description-container'
                                                                                                        style={{
                                                                                                            marginTop: laundryTabSubCategories.length > 0 ? 110 : 60,
                                                                                                            marginBottom: 16
                                                                                                        }}>
                                                                                                            <Col span={24} className='stm-tab-description'>
                                                                                                                <Row>
                                                                                                                    <Col span={3} className='stm-tab-description-image'>
                                                                                                                        <img src={require('../../assets/image/Icon/HelpInfo.svg')} alt='HelpInfo' className='stm-item-desc-image' />
                                                                                                                    </Col>
                                                                                                                    <Col
                                                                                                                        span={21}
                                                                                                                        className='stm-tab-description-text'
                                                                                                                        style={{
                                                                                                                            fontFamily: activeTemplate.templateSetting.buttonItem.fontFamily,
                                                                                                                            fontSize: activeTemplate.templateSetting.buttonItem.fontSize - 2,
                                                                                                                            lineHeight: `${activeTemplate.templateSetting.buttonItem.fontSize}px`,
                                                                                                                            color: activeTemplate.templateSetting.buttonItem.color
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        <Markup content={tab.taskDesc} />
                                                                                                                    </Col>
                                                                                                                </Row>
                                                                                                            </Col>
                                                                                                        </Row>
                                                                                                }
                                                                                            </>

                                                                                            <>
                                                                                                <div
                                                                                                    onTouchStart={(e) => this._onTouchStart(e, this)}
                                                                                                    onTouchMove={(e) => this._onTouchMove(e, this)}
                                                                                                    onTouchEnd={(e) => this._onTouchEnd(e, this, tab.taskId)}>
                                                                                                    <LaundryTabPage items={itemFilters} />
                                                                                                </div>
                                                                                            </>
                                                                                        </TabPane>
                                                                                    )
                                                                                })
                                                                            }
                                                                        </Tabs>
                                                                    </Col>
                                                                </Row>
                                                        }

                                                        {/* Footer */}
                                                        <>
                                                            {/* <Row>
                                                                <Col
                                                                    span={24}
                                                                    className='col-body-footer-next'
                                                                    style={{
                                                                        background: activeTemplate.templateSetting.footer.backgroundColor,
                                                                        fontFamily: activeTemplate.templateSetting.footer.fontFamily,
                                                                        fontSize: activeTemplate.templateSetting.footer.fontSize,
                                                                        lineHeight: `${activeTemplate.templateSetting.footer.fontSize + 2}px`,
                                                                        color: activeTemplate.templateSetting.footer.color
                                                                    }}
                                                                >
                                                                    <Row>
                                                                        <Col span={4} className='col-body-footer-next-left'>
                                                                            <img src={basketImage} alt='basket' />
                                                                        </Col>
                                                                        <Col span={8} className='col-body-footer-next-center'>
                                                                            {laundryTotalOrder} {webSettting.itemText}
                                                                        </Col>
                                                                        <Col span={9} className='col-body-footer-next-right-text' onClick={this.goToConfirmPage}>
                                                                            {webSettting.nextText}
                                                                        </Col>
                                                                        <Col span={3} className='col-body-footer-next-right' onClick={this.goToConfirmPage}>
                                                                            <Icon type='right' size='lg' color='#fff' />
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            </Row> */}
                                                        </>
                                                      </>
                                                    )}

                                                </Content>
                                            </>
                                            :
                                            null
                                    }
                                </>
                            </Layout>
                        </>
                        :
                        null
                }
            </>
        )
    }
}

export default withTranslation()(LaundryMainPage)